<script>
  import { getContext } from "svelte"
  import Grid from "./Grid.svelte"

  const { xScale, yScale } = getContext("LayerCake")

  export let mapWidth
  export let mapHeight
  export let mapBackgroundImageUrl

  const fill = mapBackgroundImageUrl ? "transparent" : "#F7F7F7"

  const mapSettings = getContext("mapSettings")
  const isEditing = $mapSettings.isEditing

  $: xStart = $xScale(0)
  $: yStart = $yScale(0)

  $: height = $yScale(mapHeight) - yStart
  $: width = $xScale(mapWidth) - xStart
</script>

<g>
  <rect x={xStart} y={yStart} {width} {height} {fill} stroke="#333" stroke-width="2" />

  {#if isEditing}
    <Grid {height} {width} {xStart} {yStart} />
  {/if}
</g>
